<template>
  <div>
    <TimelineComponent />
  </div>
</template>

<script>
import TimelineComponent from '@/components/Timeline.vue'
export default {
  name: 'Timeline',
  components: {
    TimelineComponent
  }
}
</script>

<style lang="scss">

</style>